var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.009,
    height: 25,
    viewBox: "0 0 26.009 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(471.623 -100.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    "data-name": "Path 4051",
    d: "M-458.619,419.483q-5.7,0-11.4,0a1.461,1.461,0,0,1-1.514-1.011,2.021,2.021,0,0,1-.087-.59q-.01-2.392,0-4.783a1.506,1.506,0,0,1,1.605-1.609c2.1,0,4.21,0,6.314-.006a.343.343,0,0,1,.358.237,2.956,2.956,0,0,0,2.7,1.772q2.022.049,4.045,0a2.957,2.957,0,0,0,2.714-1.8.3.3,0,0,1,.319-.21c2.123.006,4.246,0,6.369,0a1.5,1.5,0,0,1,1.576,1.555c.009,1.631,0,3.262,0,4.893a1.54,1.54,0,0,1-1.606,1.554C-451.02,419.471-454.819,419.483-458.619,419.483Zm7-2.987a1.03,1.03,0,0,0-1.011-1.01,1.029,1.029,0,0,0-.992,1,1.027,1.027,0,0,0,1.012,1.008A1.028,1.028,0,0,0-451.62,416.5Zm2.005-.008a1.009,1.009,0,0,0,1,1.008,1.012,1.012,0,0,0,.984-1,1.018,1.018,0,0,0-1-1.009A1.01,1.01,0,0,0-449.615,416.488Z",
    transform: "translate(0 -293.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4052",
    "data-name": "Path 4052",
    d: "M-374.862,109.7c-1.337,0-2.63,0-3.923,0a.967.967,0,0,1-1.057-.916,1.369,1.369,0,0,1,.147-.614,1.2,1.2,0,0,1,.285-.327q3.362-3.365,6.726-6.727a1.017,1.017,0,0,1,1.65,0q3.384,3.382,6.767,6.763a1,1,0,0,1,.364,1.092.974.974,0,0,1-1.026.731c-1.294,0-2.587,0-3.926,0v.322c0,2.169-.014,4.337.009,6.506a1.1,1.1,0,0,1-1.166,1.169c-1.256-.037-2.515-.009-3.772-.011a1,1,0,0,1-1.077-1.073q0-3.28,0-6.561Z",
    transform: "translate(-86.76)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup964);
export default __webpack_public_path__ + "static/media/Group 964.63b8ff3f705c40f73fb23b2d7c3fa4de.svg";
export { ForwardRef as ReactComponent };